// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__7kB3f","footer__frameworks":"styles_footer__frameworks__qiaUo","rotate":"styles_rotate___QKo1","rotate-reverse":"styles_rotate-reverse__gDSGq"};